<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="part" id="_idParaDest-2">Contents</h1>
<p class="center"><a href="#/ReluctantSwordsman2">Book One: How The Swordsman Was Summoned</a></p>
<p class="center"><span href="#/ReluctantSwordsman10" title="Link target outside of Sample">Book Two: How The Swordsman Received The Sword</span></p>
<p class="center"><span href="#/ReluctantSwordsman18" title="Link target outside of Sample">Book Three: How The Sword Was Named</span></p>
<p class="center"><span href="#/ReluctantSwordsman26" title="Link target outside of Sample">Book Four: How The Swordsman Was Ensnared</span></p>
<p class="center"><span href="#/ReluctantSwordsman34" title="Link target outside of Sample">Book Five: How The Swordsman Found His Brother</span></p>
<p class="center"><span href="#/ReluctantSwordsman42" title="Link target outside of Sample">The Swordsmen</span></p>
<p class="center" style="margin-top:20px;"><span href="#/ReluctantSwordsman43" title="Link target outside of Sample">About the Author</span></p>
<p class="noindent _idGenParaOverride-1">Smith — Walter Charles Smith, aged 36 years, passed away on April 8th, at Sanderson Memorial Hospital, after a brief illness. He is survived by his sister, Mrs. Cecily Smith Paddon, of Auckland, New Zealand, and an uncle, Mr. Clyde Franks, of Pasadena, California. Born in Weyback, Saskatchewan, Walter attended high school in Binghamton, New York. He obtained his Bachelor of Engineering degree from the University of Waterloo, Ontario, and an MBA from Harvard. During the past three years he was manager of the local AKL petrochemical plant. He will be greatly mourned by the many friends he made during his short stay in our community, and his willing and generous contributions to it will be sadly missed. Walter was active in the United Way, Uncles at Large, and the Historical Society, and at the time of his passing was president of Avenue Tennis Club. In accordance with his wishes, his body has been donated to medical research. Memorial service will be held at Parkdale Unitarian Church on Tuesday, April 12th, at 2 p.m. In lieu of flowers, contributions may be sent to Uncles at Large, 1215 River Road.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ReluctantSwordsman1.vue?54d58e5b